<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <div class="aiTodo">

      <div class="aiSabit" v-if="Form.Yapilacak">
        <el-popover
          placement="bottom"
          width="200"
          trigger="click">
          <a slot="reference">
            <i class="el-icon-date text-warning"></i>
          </a>
          <el-date-picker
            :disabled="lo"
            v-model="Form.Tarih"
            type="date"
            placeholder="Tarih Seçiniz"
            clearable
            format="dd.MM.yyyy">
          </el-date-picker>
        </el-popover>
        <el-tooltip class="item" effect="dark" :content="Form.Tur==1?'Sadece ben görebilirim':'Herkes görebilir'"
                    placement="bottom">

          <a class="aiTl" @click="TurDegis">
            <i :class="Form.Tur==1?'el-icon-lock text-success':'el-icon-unlock text-danger'"></i>
          </a>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="Kaydet"
                    placement="bottom">
          <a class="aiTr" @click="Ekle"><i class="el-icon-success"></i></a>
        </el-tooltip>
      </div>
      <el-input :disabled="lo" @keyup.enter.native="Ekle" placeholder="Not yazın" v-model="Form.Yapilacak"></el-input>

    </div>
    <ul class="aiList">
      <li v-for="l in Liste">
        <div class="aiListBody">
          <h5>{{ l.Icerik }}</h5>
          <h6><small class="aiListKullanici">{{ l.Kullanici }}</small>
            <el-tooltip v-if="l.tTarih" class="item" effect="dark" content="Anımsatıcı Tarihi"
                        placement="bottom">
              <small class="aiListtTarih">{{ l.tTarih }}</small>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="Ekleme Tarihi"
                        placement="bottom">
              <small class="aiListTarih">{{ l.tarih }}</small>
            </el-tooltip>
          </h6>
        </div>
        <el-popover
          placement="right"
          width="200"
          trigger="click">
          <div><a class="el-button el-button--small el-button--danger btn-block" slot="reference"
                  @click="Tamamla(l.id)">
            Silme işlemini onaylıyorum
          </a></div>
          <a class="aiListSil" slot="reference">
            <i class="el-icon-delete-solid"></i>
          </a>
        </el-popover>


      </li>
    </ul>
  </div>
</template>

<script>
import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      lo: false,
      Form: {
        Tur: 1,
        Tarih: null,
        Yapilacak: ''
      },
      Liste: null
    }
  },
  methods: {
    TurDegis() {
      if (this.Form.Tur == 1) this.Form.Tur = 2; else this.Form.Tur = 1;
    },
    Tamamla(id) {
      this.$store.dispatch("Delete", {path: 'spesiyal/yapilacak/' + id})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.SayfaYukle();

          } else {
            this.$message.error(response.Mesaj);
          }
        })
    },
    TarihOlay() {

    },
    Ekle() {
      // EKLE
      this.$store.dispatch("Post", {...this.Form, path: 'spesiyal/yapilacak'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.SayfaYukle();

          } else {
            this.$message.error(response.Mesaj);
          }
        })

    },
    SayfaYukle() {
      this.Form = {
        Tur: 1,
        Yapilacak: '',
        Tarih: null
      }
      this.lo = true;
      this.$store.dispatch("Get", {path: 'spesiyal/yapilacak'})
        .then(response => {
          this.lo = false;
          if (response.Durum == "OK") {
            this.Liste = response.Liste
          }
        })
    }
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelTodo.vue